export default __webpack_public_path__ + "static/media/020-synchronised swimming.79abf621.svg";